<!-- eslint-disable -->
<template>
    <el-container>
        <el-row class="list-container">
            <el-col :span="24">
                <el-button @click="refreshData" type="primary" size="small" icon="iconfont icon-shuaxin shuaxin">刷新</el-button>
                <el-button type="primary" size="small" icon="iconfont icon-jia shuaxin" @click="dialogFormVisible = true" :disabled="!power.recharge_card_add">新增</el-button>
                <el-button type="success" size="small" icon="iconfont icon-daochu shuaxin" @click="exportExcel">导出Excel</el-button>
            </el-col>

            <!-- search start  -->
            <el-col :span="24" class="search-content">
                <div class="search-item" style="width: 140px;">
                    <el-input v-model="data.batch_num" type="number" size="small" placeholder="请输入批号" clearable></el-input>
                </div>
                <div class="search-item" style="width: 130px;">
                    <el-select v-model="data.status" placeholder="请选择状态" size="small" clearable>
                        <el-option
                            v-for="item in [
                              {id: 1, name: '未充值'},
                              {id: 2, name: '已充值'},
                            ]"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div class="search-item">
                    <el-input v-model="data.card_num" size="small" placeholder="请输入卡号" clearable></el-input>
                </div>
                <div class="search-item">
                    <el-button size="small" icon="iconfont icon-fangdajing shuaxin" @click="search">搜索</el-button>
                </div>
            </el-col>
            <!-- search end  -->

            <el-col class="main-content">
                <el-table :data="dataList" border v-loading="loading" style="width: 100%">
                    <!-- <el-table-column type="selection" width="55"></el-table-column> -->
                    <el-table-column prop="id" label="ID" width="80"></el-table-column>

                    <el-table-column prop="card_num" label="卡号" width="190"></el-table-column>
                    <el-table-column prop="password" label="卡密" width="130"></el-table-column>
                    <el-table-column prop="money" label="面值" width="100"></el-table-column>
                    <el-table-column prop="status" label="状态" width="100">
                      <template slot-scope="scope">
                        <span style="color: #67C23A;" v-if="scope.row.status == 1">未充值</span>
                        <span style="color: #F56C6C;" v-if="scope.row.status == 2">已充值</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="user_id" label="充值用户" width="170">
                      <template slot-scope="scope" v-if="scope.row.user_id > 0">
                        <span>{{scope.row.nickname}} (ID: {{scope.row.user_id}})</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="is_frozen" label="是否冻结" width="100">
                      <template slot-scope="scope">
                        <span style="color: #67C23A;" v-if="scope.row.is_frozen == 1">正常</span>
                        <span style="color: #F56C6C;" v-if="scope.row.is_frozen == 2">冻结</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="batch_num" label="批号" width="100"></el-table-column>
                    <el-table-column prop="validity" label="有效日期" width="130"></el-table-column>
                    <el-table-column prop="recharge_at" label="充值时间" width="180"></el-table-column>
                    <el-table-column prop="created_at" label="发行时间" width="180"></el-table-column>
                    <el-table-column label="操作" min-width="180">
                        <template slot-scope="scope" v-if="scope.row.status == 1">
                            <el-button v-if="scope.row.is_frozen == 1" :disabled="loginInfo.id != 1" @click="setStatus(scope.row.id, 2, '确定要冻结吗？')" size="mini" type="danger" plain>冻结</el-button>
                            <el-button v-if="scope.row.is_frozen == 2" :disabled="loginInfo.id != 1" @click="setStatus(scope.row.id, 1, '确定要解冻吗？')" size="mini" type="warning" plain>解冻</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
            <el-col class="pagination">
                <el-pagination
                    @current-change="changePage"
                    @size-change="changePageSize"
                    background
                    :layout="pageLayout"
                    :page-sizes="pagePageSizes"
                    :page-size="pagePageSize"
                    :total="totalCount"
                    :current-page.sync="current_page"
                    :hide-on-single-page="false">
                </el-pagination>
            </el-col>
        </el-row>

        <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" :close-on-click-modal="false" @close="dialogClose" width="550px" center>
            <el-form :model="form" ref="form" class="dialog-form" @submit.native.prevent>
                <el-form-item label="面值"
                    :label-width="formLabelWidth"
                    prop="money"
                    :rules="[
                    { required: true, message: '请输入面值', trigger: 'blur' }
                    ]">
                    <el-input type="number" v-model="form.money" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="数量"
                    :label-width="formLabelWidth"
                    prop="num"
                    :rules="[
                    { required: true, message: '请输入数量', trigger: 'blur' }
                    ]">
                    <el-input type="number" v-model="form.num" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="有效日期"
                    :label-width="formLabelWidth"
                    prop="validity"
                    :rules="[
                    { required: true, message: '请选择有效日期', trigger: 'blur' }
                    ]">
                    <el-date-picker v-model="form.validity" type="date"
                      :pickerOptions="pickerOptions"
                      value-format="yyyy-MM-dd"
                      placeholder="选择有效日期"
                      autocomplete="off">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="addData('form')">确 定</el-button>
            </div>
        </el-dialog>
    </el-container>
</template>

<!-- eslint-disable -->
<script>
    import {RechargeCardIndex, RechargeCardAdd, RechargeCardSetStatus} from "@/utils/request.js"
    import {mapState} from "vuex"

    export default {
        data(){
            return {
                data: {
                    page: 1,
                    page_size: this.pagePageSize,
                    status: '',
                    card_num: '',
                    batch_num: '',
                },
                loading: false,
                dataList: [],
                totalCount: 0,
                current_page: 1,
                dialogFormVisible: false,
                loadingAdd: false,
                dialogTitle: "新增充值卡",
                formLabelWidth: "120px",
                form: {
                    id: 0,
                    money: "",
                    num: "",
                    validity: "",
                },
                pickerOptions: {
                  disabledDate(time) {
                    console.log(time.getTime() < Date.now())
                    return time.getTime() < Date.now() - 8.64e7
                  },
                }
            }
        },
        created() {
            this.getList()
        },
        computed: mapState(["power", "loginInfo"]),
        methods: {
            search() {
                this.data.page = 1
                this.current_page = 1
                this.getList()
            },
            refreshData() {
                this.data.page = 1
                this.current_page = 1
                this.loading = true

                this.getList()
            },
            getList() {
                this.loading = true
                RechargeCardIndex(this.data).then((res) => {
                    if (res.code == 200) {
                        this.data.page++
                        this.dataList = res.data.data
                        this.totalCount = res.data.count
                    } else {
                        this.$message.error("数据获取失败!")
                    }
                    this.loading = false
                })
            },
            changePage(page) {
                this.data.page = page
                this.getList()
            },
            changePageSize(size) {
                this.data.page_size = size
                this.data.page = 1
                this.current_page = 1
                this.getList()
            },
            addData(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.loadingAdd = true
                        RechargeCardAdd(this.form).then((res) => {
                            if (res.code == 200) {
                                this.$message.success(res.msg);
                                this.dialogFormVisible = false
                                this.data.page--
                                this.getList()
                            } else {
                                this.$message.error(res.msg);
                            }
                            this.loadingAdd = false
                        })
                    }
                });
            },
            editTmp(data) {
                this.form = {
                    id: data.id,
                    money: data.money,
                    validity: data.validity,
                }
                this.dialogTitle = this.form.id > 0 ? "编辑充值卡" : "新增充值卡"
                this.dialogFormVisible = true
            },
            dialogClose() {
                this.initForm()
            },
            initForm() {
                // 初始化，form数据
                this.form = {
                    id: 0,
                    money: "",
                    num: "",
                    validity: "",
                }
                // 重置字段验证
                this.$refs["form"].resetFields();
                this.dialogTitle = "新增充值卡"
            },
            setStatus(id, status, msg) {
            	this.$confirm(msg, '提示', {
            		confirmButtonText: '确定',
            		cancelButtonText: '取消',
            		type: 'warning'
            	}).then(() => {
            		RechargeCardSetStatus({id: id, status: status}).then((res) => {
            			if (res.code == 200) {
            				this.data.page--
            				this.getList()
            				this.$message.success(res.msg);
            			} else {
            				this.$message.error(res.msg);
            			}
            		})
            	}).catch(() => {
            		// 取消操作
            	});
            },
            exportExcel(type) {
              this.$confirm("确定要导出列表数据吗?", "提示", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "success"
              }).then(() => {
                  let url = '';
                  for(var k in this.data){
                    let value = this.data[k] !==undefined ? this.data[k] : '';
                    if (k == 'page') { continue }
                    url += `&${k}=${encodeURIComponent(value)}`
                  }
                  url += `&type=${type}`
                  if (this.loginInfo.id == 1) {
                    url += `&auth=xj2020`
                  }
                  location.href = this.loginInfo.app_url+'/manage/recharge-card/excel?' + url.substring(1)
              }).catch(() => {
                  // 取消操作
              });
            },
        }
    }
</script>

<style>
</style>
